<template>
  <div class="marketing-sms-form-senders-list">

    <div class="marketing-sms-form-senders-list-header">
      <v-text-field v-model="searchText"
                    label="Pesquisar..."></v-text-field>
    </div>

    <v-data-table class="marketing-sms-form-senders-list-table"
                  :headers="headers"
                  :items="sendTypes"
                  :loading="loading"
                  :hide-actions="true"
                  :search="searchText"
                  no-data-text="Nenhum plano cadastrado"
                  no-results-text="Sem dados"
                  hide-headers
                  disable-initial-sort>

      <template slot="items"
                slot-scope="props">
        <marketing-form-senders-list-item :item="props.item"
                                          :selected-item="value"
                                          @selected="setSelectedItem" />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import MarketingFormSendersListItem from "@components/modules/marketing/generic/form/senders/list/item/MarketingFormSendersListItem";

export default {
  components: {
    MarketingFormSendersListItem,
  },

  data() {
    return {
      sendTypes: [],
      headers: [
        { text: "", value: "", sortable: false, width: 50 },
        { text: "", value: "label", sortable: false },
      ],
      loading: false,
      searchText: "",
    };
  },

  props: {
    value: {
      type: String,
    },
  },

  methods: {
    async loadSendType() {
      try {
        this.loading = true;

        this.sendTypes = await this.$api.marketing.channel.sendtype();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    setSelectedItem(selectedVal) {
      this.$emit("input", selectedVal);
    },
  },

  created() {
    this.loadSendType();
  },

  computed: {},

  mixins: [],
};
</script>

<style lang="scss" scoped>
.marketing-sms-form-senders-list {
  padding: 0 20px 10px;
  border: 2px solid #c4c4c4;
  border-radius: 8px;
  height: 350px;
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;

  .marketing-sms-form-senders-list-header {
    padding: 20px 0 0 0;
  }

  .marketing-sms-form-senders-list-table {
    overflow-y: auto;
  }
}
</style>
